import { useState, useEffect } from "react";
import GcrLogo from "./GcrLogo";

const STORAGE_KEY = "betiq_age_verified";

export default function AgeGateModal() {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem(STORAGE_KEY);
    if (!verified) setVisible(true);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  const handleDecline = () => {
    setLeaving(true);
    setTimeout(() => { window.location.href = "https://www.google.com"; }, 600);
  };

  return (
    <>
      {/* Backdrop — blur sobre la página real, NO negro sólido */}
      <div
        className="fixed inset-0 z-[9998]"
        style={{
          backdropFilter: "blur(6px) brightness(0.45)",
          WebkitBackdropFilter: "blur(6px) brightness(0.45)",
          background: "rgba(0,0,0,0.35)",
        }}
      />

      {/* Modal */}
      <div
        className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
        data-testid="age-gate-overlay"
      >
        <div
          className="relative w-full rounded-2xl overflow-hidden"
          style={{
            maxWidth: 340,
            background: "linear-gradient(160deg, #16161E 0%, #0E0E14 100%)",
            border: "1px solid rgba(212,175,55,0.2)",
            boxShadow: "0 24px 60px -8px rgba(0,0,0,0.7), 0 0 0 1px rgba(212,175,55,0.05)",
            animation: leaving
              ? "ageOut 0.45s ease forwards"
              : "ageIn 0.3s cubic-bezier(0.34,1.4,0.64,1) forwards",
          }}
          data-testid="age-gate-modal"
        >
          {/* Gold hairline top */}
          <div className="h-[1.5px]" style={{ background: "linear-gradient(90deg, transparent 0%, #D4AF37 50%, transparent 100%)" }} />

          <div className="px-6 py-6 flex flex-col items-center text-center">

            {/* Logo */}
            <div className="mb-4">
              <GcrLogo size={28} />
            </div>

            {/* Divider */}
            <div className="w-8 h-px mb-4" style={{ background: "rgba(212,175,55,0.25)" }} />

            {/* Heading */}
            <h2 className="text-[19px] font-black mb-2 leading-snug" style={{ color: "#fff", letterSpacing: "-0.3px" }}>
              ¿Eres mayor de 18 años?
            </h2>

            {/* Body */}
            <p className="text-[12px] leading-relaxed mb-1" style={{ color: "#71717A" }}>
              Este sitio contiene contenido relacionado con apuestas deportivas.
            </p>
            <p className="text-[12px] leading-relaxed mb-5" style={{ color: "#52525B" }}>
              Al continuar confirmas que tienes{" "}
              <span style={{ color: "#A1A1AA", fontWeight: 700 }}>18 años o más</span>{" "}
              y que las apuestas son legales en tu país.
            </p>

            {/* Buttons */}
            <button
              onClick={handleAccept}
              data-testid="age-gate-accept"
              className="w-full py-3 rounded-xl font-black text-[12px] tracking-widest uppercase mb-2 transition-all duration-150 active:scale-95"
              style={{
                background: "linear-gradient(135deg,#D4AF37 0%,#B8941F 100%)",
                color: "#0A0A0C",
                boxShadow: "0 6px 20px -4px rgba(212,175,55,0.45)",
              }}
            >
              Sí, soy mayor de 18
            </button>

            <button
              onClick={handleDecline}
              data-testid="age-gate-decline"
              className="w-full py-2.5 rounded-xl font-medium text-[12px] transition-all duration-150 active:scale-95"
              style={{ background: "transparent", border: "1px solid rgba(255,255,255,0.06)", color: "#4B4B55" }}
            >
              No, salir del sitio
            </button>

            {/* Responsible gambling */}
            <p className="text-[10px] mt-4" style={{ color: "#3F3F46" }}>
              Juega con responsabilidad · +18
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ageIn {
          from { opacity: 0; transform: scale(0.92) translateY(12px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes ageOut {
          from { opacity: 1; transform: scale(1); }
          to   { opacity: 0; transform: scale(0.95); }
        }
      `}</style>
    </>
  );
}
